/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TermsOfUsePopupComponent } from './terms-of-use-popup/terms-of-use-popup.component';
import { PrivacyPolicyPopupComponent } from './privacy-policy-popup/privacy-policy-popup.component';

@Component({
  selector: 'curr-static-pages',
  templateUrl: './static-pages.component.html',
  styleUrls: ['./static-pages.component.scss']
})
export class StaticPagesComponent implements OnInit {

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openTermsOfUse(): void {
    this.dialog.open(TermsOfUsePopupComponent, {
      width: '80%',
      maxWidth: '900px',
      maxHeight: '90vh',
      autoFocus: false
    });
  }

  openPrivacyPolicy(): void {
    this.dialog.open(PrivacyPolicyPopupComponent, {
      width: '80%',
      maxWidth: '900px',
      maxHeight: '90vh',
      autoFocus: false
    });
  }
}
